export default __webpack_public_path__ + "static/media/21-2021-sedi-sine-informativo.a5c3d7a5.pdf";